import {getElementByElementOrId} from "../../../helpers/element";
import {SecondaryPaneComponentConfig} from "../components/secondary_pane_component";
import {SecondaryPane} from "../models/secondary_pane";
import Collection from "../../../lib/collection";

export class SecondaryPanesManager {

    static new(parentElement, panesManager) {
        const element = parentElement;
        if (!element) {
            return null
        }
        return new SecondaryPanesManager(element, panesManager)
    }

    constructor(id_or_element, panesManager) {
        const element = getElementByElementOrId(id_or_element);
        this.panes = constructPanes(element, this);
        this.panesManager = panesManager;
        this.nav = panesManager?.nav;
    }

    getPanesCollection() {
        return new Collection().concat(this.panes);
    }

    closePanes() {
        this.panesManager.closeSecondaryPanes();
    }
}

function constructPanes(parentElement, secondaryPanesManager) {
    let panes = [];
    let elements = parentElement.querySelectorAll(SecondaryPaneComponentConfig.selector);
    elements.forEach((element) => {
        let pane = SecondaryPane.new(element, secondaryPanesManager);
        panes.push(pane);
    });
    return panes;
}